import React, { useState, useEffect } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Switch,
  TextField,
  IconButton,
  Button,
  makeStyles,
  CircularProgress,
  Typography,
  Grid
} from "@material-ui/core";
import DeleteIcon from "@material-ui/icons/Delete";
import StyledButton from "../../../common/models/Button";
import { appUrl } from "../../../../utils/config";
import axios from "axios";
import SaveIcon from "@material-ui/icons/Save";
import CancelIcon from "@material-ui/icons/Cancel";
import ChevronLeftIcon from "@material-ui/icons/ChevronLeft";
import ChevronRightIcon from "@material-ui/icons/ChevronRight";

const useStyles = makeStyles((theme) => ({
  container: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    padding: theme.spacing(2),
  },
    saveButton: {
    backgroundColor: "#EC6535",
    color: "#fff",
    borderRadius: "20px",
    // padding: "8px 24px",
    textTransform: "none",
    width: "12rem",
    fontSize: "1rem",
    fontWeight: 550,
    cursor: "pointer",
    // paddingLeft:"3rem",
    // paddingRight:"3rem",
    paddingTop: "0.35rem",
    paddingBottom: "0.35rem",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    borderRadius: "5rem",
    "&:hover": {
      backgroundColor: "#993d13",
    },
  },
  backButton: {
    backgroundColor: "#707070",
    color: "#fff",
    borderRadius: "20px",
    // padding: "8px 24px",
    textTransform: "none",
    width: "12rem",
    fontSize: "1rem",
    fontWeight: 550,
    cursor: "pointer",
    // paddingLeft:"3rem",
    // paddingRight:"3rem",
    paddingTop: "0.35rem",
    paddingBottom: "0.35rem",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    borderRadius: "5rem",
    "&:hover": {
      backgroundColor: "#4d4d4d",
    },
  },
  table: {
    backgroundColor: "#fff",
    border: "1px solid #ddd",
    width: "600px",
  },
  headerCell: {
    fontWeight: 600,
    color: "#333",
    backgroundColor: "#f0f0f0",
    padding: "10px 16px",
    textAlign: "left",
  },
  bodyCell: {
    padding: "10px 16px",
    textAlign: "left",
    verticalAlign: "middle",
  },
  textField: {
    "& input": {
      padding: "6px 8px",
      height: "30px",
    },
  },
  addButton: {
    marginTop: theme.spacing(2),
    backgroundColor: "#fff",
    color: "#000",
    borderRadius: "20px",
    padding: "6px 16px",
    textTransform: "none",
    fontWeight: 600,
    border: "1px solid #000",
    display: "flex",
    alignItems: "center",
    "&:hover": {
      backgroundColor: "#f5f5f5",
    },
  },
  addIconCircle: {
    width: "24px",
    height: "24px",
    borderRadius: "50%",
    border: "2px solid #000",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginRight: theme.spacing(1),
    fontSize: "16px",
    fontWeight: 600,
  },
  iconBtn: {
    padding: "2px",
  },
  inlineActions: {
    display: "flex",
    flexDirection: "column",
    marginLeft: 8,
  },
  deleteIcon: {
    color: theme.palette.error.main,
  },
  switchBase: {
    "&.Mui-checked": {
      color: "#007bff",
    },
    "&.Mui-checked + .MuiSwitch-track": {
      backgroundColor: "#007bff",
    },
  },
  footer: {
    display: "flex",
    justifyContent: "space-between",
    width: "90%",
    marginTop: theme.spacing(4),
  },
}));

const PlantTypeTab = (props) => {
  const { addSponsorList, rowData,updateNetworkData,rowNetwork } = props;
  const classes = useStyles();

  const [plantTypes, setPlantTypes] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [errorMessage, setErrorMessage] = useState("");

  const [isUpdated, setIsUpdated] = useState(false);
  const [savingStates, setSavingStates] = useState({});
  const [isSaving, setIsSaving] = useState(false); // Track save & next button loading

  const dispatch = (action) => {
    if (action.type === "OPEN_BACKDROP") {
    } else if (action.type === "DESTROY_BACKDROP") {
    }
  };

    const network=addSponsorList?.data?.network || rowNetwork;
   const networkUrl=updateNetworkData?.ecosystemUrl || rowData?.networkURL;

  const fetchPlantTypes = async () => {
    setError(null);
    setLoading(true);
    dispatch({ type: "OPEN_BACKDROP" });

    try {
      const url = `${networkUrl}/Pharma%20Contract%20Manufacturing/${network}/Pharma%20Co/Admin/fetchPlantTypes/false`;
      const response = await axios.get(url);
      const data = response?.data?.data;


      if (data?.status === true || data?.status === "true") {
        const list = data.plantTypeList || [];

        const formatted = list.map((item, index) => ({
          ...item,
          id: item.plantTypeID || `ID-${index + 1}`,
          name: item.plantTypeName || "",
          selected: !!item.activated,
          isNew: false,
        }));

        setPlantTypes(formatted);
      } else {
        setError("Something went wrong. Please try again.");
      }
    } catch (err) {
      console.error("API Error:", err);
      setError("Something went wrong. Please try again.");
    } finally {
      setLoading(false);
      dispatch({ type: "DESTROY_BACKDROP" });
    }
  };

  useEffect(() => {
    fetchPlantTypes();
  }, []);

  const saveNewPlantType = async () => {
    try {
      const newPlantTypes = plantTypes.filter((plantType) => plantType.isNew);
      if (newPlantTypes.length === 0) {
        return;
      }

      const payload = {
        ecosystemId:addSponsorList?.data?.ecosystemId || rowData?.ecosystemId,
      sponsorId: addSponsorList?.data?.organizationId || rowData?.organizationId,
        plantTypeList: newPlantTypes.map(({ id, name, selected }) => ({
          plantType: "New",
          plantTypeName: name,
          activated: selected,
        })),
      };

      const url = `${networkUrl}/Pharma%20Contract%20Manufacturing/${network}/Pharma%20Co/Admin/addPlantTypes`;
      const response = await axios.post(url, payload);
      if (response.data?.status === true) {
        fetchPlantTypes();
        props.setPlantType((prev) => !prev); 
      } else {
        console.error("Failed to save new plant types.");
      }
    } catch (error) {
      console.error("Error saving new plant types:", error);
    }
  };

  const deletePlantType = async (plantType) => {
    try {
      if (plantType.isNew) {
        setPlantTypes((prevPlantTypes) =>
          prevPlantTypes.filter((item) => item.id !== plantType.id)
        );
      } else {
        const url = `${networkUrl}/Pharma%20Contract%20Manufacturing/${network}/Pharma%20Co/Admin/updatePlantTypes`;
        const payload = {
          ecosystemId:addSponsorList?.data?.ecosystemId || rowData?.ecosystemId,
      sponsorId: addSponsorList?.data?.organizationId || rowData?.organizationId,
          plantTypeList: [
            {
              plantTypeID: plantType.id,
              plantTypeName: plantType.name,
              activated: plantType.selected,
              markForDelete: true,
            },
          ],
        };
        const response = await axios.post(url, payload);
       
        if (response.data?.status === true) {
          fetchPlantTypes();
          props.setPlantType((prev) => !prev);
        } else {
          console.error("Failed to delete plant type.");
        }
      }
    } catch (error) {
      console.error("Error deleting plant type:", error);
    }
  };

  const handleNextClick = async () => {
    try {
      // Check if at least one plant type is selected
      const isAnyPlantTypeSelected = plantTypes.filter(
        (plantType) => plantType.isUpdated
      );

      if (!isAnyPlantTypeSelected.length) {
        props.handleNext(); // Directly move to the next tab
        return;
      }
      // if (!isAnyPlantTypeSelected.length) {
      //   setErrorMessage("Please select at least one plant type.");
      //   return;
      // }
      if (plantTypes.every((plantType) => !plantType.selected)) {
        setErrorMessage("Please enable at least one in toggle mode.");
        return;
      }

      setIsSaving(true); // Start loading

      // Prepare the payload
      const payload = {
         ecosystemId:addSponsorList?.data?.ecosystemId || rowData?.ecosystemId,
      sponsorId: addSponsorList?.data?.organizationId || rowData?.organizationId,
        plantTypeList: isAnyPlantTypeSelected.map(({ id, name, selected }) => ({
          plantTypeID: id,
          plantTypeName: name,
          activated: selected,
          markForDelete: false,
        })),
      };

      // Call the API
      const url = `${networkUrl}/Pharma%20Contract%20Manufacturing/${network}/Pharma%20Co/Admin/updatePlantTypes`;
      const response = await axios.post(url, payload);

      if (response.data?.data?.status === true) {
        fetchPlantTypes(); // Refresh the list after successful update
        props.handleNext(); // Proceed to the next step
      } else {
        console.error("Failed to update plant types.");
        setErrorMessage("Failed to update plant types. Please try again.");
      }
    } catch (error) {
      console.error("Error updating plant types:", error);
      setErrorMessage(
        "An error occurred while updating plant types. Please try again."
      );
    } finally {
      setIsSaving(false); // Stop loading
    }
  };

  const handleToggle = (index) => {
    const updated = [...plantTypes];
    updated[index].selected = !updated[index].selected;
    updated[index].isUpdated = true;
    setPlantTypes(updated);
    setIsUpdated(true);
  };

  const handleNameChange = (index, value) => {
    const updated = [...plantTypes];
    updated[index].name = value;
    setPlantTypes(updated);
    setIsUpdated(true);
  };

  // const handleDelete = (index) => {
  //   const updated = plantTypes.filter((_, i) => i !== index);
  //   setPlantTypes(updated);
  // };

  const handleAddPlantType = () => {
    // const nextId = (plantTypes.length + 1).toString().padStart(2, "0");
    setPlantTypes([
      ...plantTypes,
      {
        // id: nextId,
        name: "",
        selected: false,
        isNew: true,
      },
    ]);
  };

  const handleSaveNew = async (index) => {
    if (savingStates[index]) return;
    setSavingStates((prev) => ({ ...prev, [index]: true }));
    const plantType = plantTypes[index];
    const success = await saveNewPlantType(plantType);

    if (success) {
      // Refresh full list from API after successful save
      await fetchPlantTypes();
    } else {
      // alert("Failed to save new plantType.");
    }
    setSavingStates((prev) => ({ ...prev, [index]: false }));
  };

  const handleCancel = (index) => {
    const plantType = plantTypes[index]; // Get the plantType by index
    // Log plantType and index
    const updated = plantTypes.filter((_, i) => i !== index);
    setPlantTypes(updated);
  };

  return (
    <div className={classes.container}>
      <Table className={classes.table}>
        <TableHead>
          <TableRow>
            <TableCell className={classes.headerCell}>Selection</TableCell>
            <TableCell className={classes.headerCell}>Plant Type</TableCell>
            <TableCell className={classes.headerCell}>Plant Type ID</TableCell>
            <TableCell className={classes.headerCell}>Action</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {loading ? (
            <TableRow>
              <TableCell colSpan={4}>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    height: "100px",
                  }}
                >
                  <CircularProgress />
                </div>
              </TableCell>
            </TableRow>
          ) : error ? (
            <TableRow>
              <TableCell colSpan={4}>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    height: "60px",
                    backgroundColor: "#ffecec",
                    color: "#b00020",
                    border: "1px solid #ff9999",
                  }}
                >
                  <Typography>{error}</Typography>
                </div>
              </TableCell>
            </TableRow>
          ) : (
            plantTypes.map((plantType, index) => (
              <TableRow key={plantType.id}>
                <TableCell className={classes.bodyCell}>
                  <Switch
                    checked={plantType.selected}
                    onChange={() => handleToggle(index)}
                    classes={{ switchBase: classes.switchBase }}
                  />
                </TableCell>
                <TableCell className={classes.bodyCell}>
                  {plantType.isNew ? (
                    <div style={{ display: "flex", alignItems: "center" }}>
                      <TextField
                        placeholder="Type Text Here"
                        value={plantType.name}
                        onChange={(e) =>
                          handleNameChange(index, e.target.value)
                        }
                        className={classes.textField}
                        variant="outlined"
                        inputProps={{
                            onBeforeInput: (e) => {
                              const allowedChars = /^[a-zA-Z\s\-\/,().]+$/;
                              if (!allowedChars.test(e.data)) {
                                e.preventDefault();
                              }
                            }
                          }}
                      />
                      <div className={classes.inlineActions}>
                        <IconButton
                          onClick={() => handleCancel(index)}
                          className={classes.iconBtn}
                        >
                          <CancelIcon fontSize="small" />
                        </IconButton>
                        <IconButton
                            onClick={() => handleSaveNew(index)}
                            className={classes.iconBtn}
                            disabled={
                              !plantTypes[index].name?.trim() ||
                              plantTypes.some(
                                (p, i) => i !== index &&
                                  p.name?.trim().toLowerCase() === plantTypes[index].name?.trim().toLowerCase()
                              ) || savingStates[index]
                            }
                            >
                          <SaveIcon fontSize="small" />
                        </IconButton>
                      </div>
                    </div>
                  ) : (
                    plantType.name
                  )}
                </TableCell>
                <TableCell className={classes.bodyCell}>
                  {plantType.id}
                </TableCell>
                <TableCell className={classes.bodyCell}>
                  {/* Add this line */}
                  {(plantType.isNew === true ||
                    plantType.plantType === "New") && (
                    <IconButton
                      aria-label="delete"
                      onClick={() => deletePlantType(plantType)}
                    >
                      <DeleteIcon className={classes.deleteIcon} />
                    </IconButton>
                  )}
                </TableCell>
              </TableRow>
            ))
          )}
        </TableBody>
      </Table>
      {errorMessage && (
        <div style={{ color: "red" }} className="error-message">
          {errorMessage}
        </div>
      )}
      <Button
        variant="outlined"
        onClick={handleAddPlantType}
        className={classes.addButton}
      >
        <span className={classes.addIconCircle}>+</span>
        Add New Plant Type
      </Button>

      <div className={classes.footer}>
        <Grid
          className={classes.backButton}
          onClick={() => {
            props.handleBack();
          }}
        >
          <ChevronLeftIcon />
          Back
        </Grid>
        <Grid
          className={classes.saveButton}
          onClick={() => {
            if (isUpdated) {
              handleNextClick(); // Call API and move to the next tab if updates are made
            } else {
              props.handleNext(); // Directly move to the next tab if no updates are made
            }
          }}
          style={{ 
            opacity: isSaving ? 0.7 : 1, 
            pointerEvents: isSaving ? 'none' : 'auto' 
          }}
        >
          {isSaving ? (
            <>
              <CircularProgress size={16} color="inherit" style={{ marginRight: '8px' }} />
              Saving...
            </>
          ) : (
            <>
              Save & Next
              <ChevronRightIcon />
            </>
          )}
        </Grid>
      </div>
    </div>
  );
};

export default PlantTypeTab;
